<template lang="html">
    <div class="loadChargeIn" v-if="active > 0">
        <div class="coin" :class="active == 1 ? 'run' : ''">
            <div class="h-100 w-100 position-relative d-flex justify-content-center align-items-center align-content-center">
                <img :src="logo" class="mbLogo">
                <img :src="a13" class="spinner">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "loaderAnimIn",
    props: {
        active: {
            default: 0,
            type: Number
        },
        transNext: {
            default: 0,
            type: Number
        }
    },
    data() {
        return {
            a13:require('@/assets/images/a13.png'),
            logo:require('@/assets/images/franchise/logo.jpg'),
        }
    },
}
</script>
<style lang="css" scoped>
.loadChargeIn {
    width: 100vw;
    height: 100vh;
    position: fixed;
    pointer-events: all;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    z-index: 9999;
    overflow: hidden;
    animation: fade 1s forwards;
    background-color: rgba(255, 255, 255, 0.3);
}

.coin:not(.run){
    pointer-events: none;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.7);
    animation: expanse 0.5s 1 forwards;
}

.coin {
    position: relative;
    width: 180px;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mbLogo{
    width: 140px;
    height: 140px;
    border-radius: 50%;
    object-fit: cover;
    position: absolute;
    margin: auto;
    pointer-events: none;
}

.loadChargeIn .spinner{
    width: 170px;
    height: 170px;
    position: absolute;
    margin: auto;
    pointer-events: none;
}
.coin.run .spinner{
    display: block;
    animation: charge 1s linear infinite;
}
.coin:not(.run) .spinner{
    display: none !important;
}

</style>
